import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/img/common/icon-arrow-left.svg'
import _imports_1 from '@/assets/img/common/img-pagetop.svg'


const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#f3f3f3"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-recommend --no-pt-sp" }
const _hoisted_4 = { class: "p-recommend-back" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "戻る",
  width: "24",
  height: "24"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "ログインID・メールアドレス変更", -1)
const _hoisted_8 = ["onSubmit"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "p-mail-security-block u-mn-hidden" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "p-mail-security-heading-1" }, "ログインID・メールアドレス変更")
], -1)
const _hoisted_10 = {
  key: 0,
  class: "p-mail-security-block"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", { class: "p-mail-security-heading-2" }, "ご確認", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("・ログインIDとメールアドレス1が同じになるよう、メールアドレスをご確認・変更してください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("・ご本人様確認のため、メールアドレスの認証をお願いします。​")
], -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "p-mail-security-block" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h2", { class: "p-mail-security-heading-2" }, "ログインID", -1)
const _hoisted_16 = { class: "-is-mail" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "-is-notice-1" }, "※メールアドレス1の内容に変更されます。", -1)
const _hoisted_18 = { class: "p-mail-security-block u-mb-16" }
const _hoisted_19 = { class: "p-mail-security-heading-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "p-mail-security-icon --icon-1" }, "必須", -1)
const _hoisted_21 = { class: "p-mail-security-icon --icon-2" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = {
  key: 1,
  class: "p-mail-security-notice u-mb-8-sp u-mb-10-pc"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 1,
  class: "p-mail-security-block"
}
const _hoisted_26 = { class: "p-mail-security-heading-2" }
const _hoisted_27 = {
  key: 0,
  class: "p-mail-security-icon --icon-2"
}
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = {
  key: 1,
  class: "p-mail-security-notice --error u-mb-8-sp u-mb-10-pc"
}
const _hoisted_30 = {
  key: 2,
  class: "p-mail-security-notice u-mb-8-sp u-mb-10-pc"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "p-mail-security-block" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-7" }, "メールアドレスの認証依頼の送信に失敗しました。", -1)
const _hoisted_35 = { class: "l-wrapper_nav" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_38 = [
  _hoisted_37
]

import { computed, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { debounce } from 'lodash';
import * as yup from 'yup';
import store from '@/store';
import { errorMessage } from '@/constants/validationErrors';
import VALIDATON_ERRORS from '@/constants/validationErrors';
import Loading from '@/components/Loading.vue';
import { postMailSecurityUpdateKey } from '@/api/accountEndpoint';
import { 
  MailSecurityInfoDetail, 
  MailSecurityItemError, 
  MailSecurityUpdateKeyDetail, 
  MailSecurityUpdateKeyResponse, 
  NewMailSecurityRequest } 
from '@/types/emailSerurity';
import { domHelperUtils } from '@/utils/domHelper';
import MailSecurityPopupView from './MailSecurityPopupView.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MailSecurityFormView',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const isLoading = ref(false);
const emailSecutiryInfo = ref<MailSecurityInfoDetail|undefined>();
const loginId = ref<string>('');
const email1 = ref<string>('');
const email2 = ref<string>('');
const email1Origin = ref<string>('');
const email2Origin = ref<string>('');
const isEmail1Error = ref<boolean>(false);
const isEmail2Error = ref<boolean>(false);
const email1ErrorMsg = ref<string>('');
const email2ErrorMsg = ref<string>('');
const listEmailSuggest = ref<Array<string>>([]);
const isEnableSubmitButton = ref<boolean>(true);
const isShowAlertErrorSendMail = ref(false);
const isDisabledSubmit = ref(false);
const isCommonLayoutVisibleOnForm = ref(false);
const isDuplicateEmailError = ref(false);
const email1AuthFlgOrigin = ref<number>(0);
const email2AuthFlgOrigin = ref<number>(0);
const DUPLICATE_EMAIL_ERROR_MESSAGE = 'メールアドレス1とメールアドレス2には、異なるアドレスを入力してください。';
const EMAIL2_CLEAR_NOTICE_MESSAGE = errorMessage('EMAIL2_CLEAR_NOTICE');
const NO_QUOTE_BEFORE_AT_REGEX = /^[^']+@.*$/;
// Allowed chars aligned with backend EmailFormat: alphanumeric + -!#$%&*+/=?^_`{|}~.
const ALLOWED_EMAIL_LOCAL_CHARS = new Set('abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-!#$%&*+/=?^_`{|}~.'.split(''));
// Domain: only alphanumeric, hyphen, dot (standard DNS label)
const ALLOWED_EMAIL_DOMAIN_CHARS = new Set('abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-.'.split(''));
const AUTH_FLG_AUTHENTICATED = 1;
const email1Input = ref<HTMLInputElement | null>(null);
const email2Input = ref<HTMLInputElement | null>(null);

const normalizeEmail = (email: string) => (email ?? '').trim().toLowerCase();

// Dynamic auth label for メールアドレス1 (always visible)
const email1AuthLabel = computed((): '認証済' | '未認証' => {
  const email1Normalized = normalizeEmail(email1.value);

  if (
    email1Normalized === normalizeEmail(email1Origin.value) &&
    email1Normalized !== '' &&
    email1AuthFlgOrigin.value === AUTH_FLG_AUTHENTICATED &&
    email1Normalized !== normalizeEmail(email2.value)
  ) {
    return '認証済';
  }

  return '未認証';
});

// Dynamic auth label for メールアドレス2
const email2AuthLabel = computed((): '認証済' | '未認証' | null => {
  const email2Normalized = normalizeEmail(email2.value);
  const email2OriginNormalized = normalizeEmail(email2Origin.value);
  // hide label if email2 is not registered in TRNCAREER
  if (!email2OriginNormalized) return null;

  if (
    email2Normalized === email2OriginNormalized &&
    email2Normalized !== '' &&
    email2AuthFlgOrigin.value === AUTH_FLG_AUTHENTICATED &&
    email2Normalized !== normalizeEmail(email1.value)
  ) {
    return '認証済';
  }

  return '未認証';
});

// Swap notice: authenticated email2 moved into email1 field
const isShowEmail1SwapNotice = computed((): boolean => {
  const email1Normalized = normalizeEmail(email1.value);
  const email2OriginNormalized = normalizeEmail(email2Origin.value);
  return (
    email1Normalized !== '' &&
    email2OriginNormalized !== '' &&
    email1Normalized === email2OriginNormalized &&
    email2AuthFlgOrigin.value === AUTH_FLG_AUTHENTICATED &&
    email1Normalized !== normalizeEmail(email1Origin.value) &&
    !isDuplicateEmailError.value
  );
});

// Swap notice: authenticated email1 moved into email2 field
const isShowEmail2SwapNotice = computed((): boolean => {
  const email2Normalized = normalizeEmail(email2.value);
  const email1OriginNormalized = normalizeEmail(email1Origin.value);
  return (
    email2Normalized !== '' &&
    email1OriginNormalized !== '' &&
    email2Normalized === email1OriginNormalized &&
    email1AuthFlgOrigin.value === AUTH_FLG_AUTHENTICATED &&
    email2Normalized !== normalizeEmail(email2Origin.value) &&
    !isDuplicateEmailError.value
  );
});

const filterSuggestEmails = (currentEmail: string, otherEmail: string) => {
  const normalizedCurrent = normalizeEmail(currentEmail);
  const normalizedOther = normalizeEmail(otherEmail);

  return listEmailSuggest.value.filter((suggestEmail) => {
    const normalizedSuggest = normalizeEmail(suggestEmail);
    return normalizedSuggest !== normalizedCurrent && normalizedSuggest !== normalizedOther;
  });
};

const listEmailSuggestForEmail1 = computed(() =>
  filterSuggestEmails(email1.value, email2.value)
);

const listEmailSuggestForEmail2 = computed(() =>
  filterSuggestEmails(email2.value, email1.value)
);

const showEmail2ClearNotice = computed(() => {
  const hasRegisteredEmail2 = normalizeEmail(email2Origin.value) !== '';
  const isEmail2InputEmpty = normalizeEmail(email2.value) === '';

  return hasRegisteredEmail2 && isEmail2InputEmpty;
});

const isShowProcedure = computed(() => route.query?.from === 'mail-security-setting');

const isEmail2InputVisible = computed(() => {
  const hasRegisteredEmail2 = normalizeEmail(email2Origin.value) !== '';
  const isFromMailSecuritySetting = route.query?.from === 'mail-security-setting';

  if (isFromMailSecuritySetting && !hasRegisteredEmail2) {
    return false;
  }

  return true;
});

onMounted(async () => {
  document.body.style.overflow = '';
  isCommonLayoutVisibleOnForm.value = route.meta.header === 'mypage' && route.meta.footer === 'home';

  await store.dispatch('mailSecurity/clear');
  await store.dispatch('mailSecurity/receive');
  emailSecutiryInfo.value = store.getters['mailSecurity/mailSecurity'];
  if(emailSecutiryInfo.value) {
    loginId.value = emailSecutiryInfo?.value?.loginId ?? '';
    email1Origin.value = emailSecutiryInfo?.value?.email1 ?? '';
    email2Origin.value = emailSecutiryInfo?.value?.email2 ?? '';
    email1AuthFlgOrigin.value = emailSecutiryInfo?.value?.email1AuthFlg ?? 0;
    email2AuthFlgOrigin.value = emailSecutiryInfo?.value?.email2AuthFlg ?? 0;
    email1.value = emailSecutiryInfo?.value?.email1 ?? '';
    email2.value = emailSecutiryInfo?.value?.email2 ?? '';
    
    // Add email suggest to list display (unique, non-empty)
    const candidates = [
      emailSecutiryInfo?.value?.loginId ?? '',
      emailSecutiryInfo?.value?.email1 ?? '',
      emailSecutiryInfo?.value?.email2 ?? ''
    ];
    listEmailSuggest.value = candidates.filter(
      (email, index) => email !== '' && candidates.indexOf(email) === index
    );
  }
  validateEmail1();
  validateEmail2();
  setIsEnableSubmitButton();
});

const validateEmail1 = debounce(async () => {
  email1Input.value?.removeAttribute("title");
  try {
    const res = await yup.string()
      .label('メールアドレス1')
      .required(VALIDATON_ERRORS.REQUIRED)
      .max(255, VALIDATON_ERRORS.MAX_LENGTH)
      .email(VALIDATON_ERRORS.EMAIL)
      .matches(NO_QUOTE_BEFORE_AT_REGEX, { message: VALIDATON_ERRORS.EMAIL, excludeEmptyString: true })
      .validate(email1.value);
    isEmail1Error.value = false;
    email1ErrorMsg.value = '';
    loginId.value = res;
    setIsEnableSubmitButton();
  } catch (err) {
    const error = err as yup.ValidationError;
    isEmail1Error.value = true;
    email1ErrorMsg.value = error?.message ?? '';
    validationEmailContainProhibitedSymbols(email1.value, email1Input.value);
  } finally {
    validateDuplicateEmail();
  }
}, 0);

const validateEmail2 = debounce(async () => {
  email2Input.value?.removeAttribute("title");
  try {
    await yup.string()
      .label('メールアドレス2')
      .max(255, VALIDATON_ERRORS.MAX_LENGTH)
      .email(VALIDATON_ERRORS.EMAIL)
      .matches(NO_QUOTE_BEFORE_AT_REGEX, { message: VALIDATON_ERRORS.EMAIL, excludeEmptyString: true })
      .validate(email2.value);
    isEmail2Error.value = false;
    email2ErrorMsg.value = '';
    setIsEnableSubmitButton();
  } catch (err) {
    const error = err as yup.ValidationError;
    isEmail2Error.value = true;
    email2ErrorMsg.value = error?.message ?? '';
    validationEmailContainProhibitedSymbols(email2.value, email2Input.value);
  } finally {
    validateDuplicateEmail();
  }
}, 0);

const validationEmailContainProhibitedSymbols = (email: string, emailEl: HTMLInputElement | null) => {
  const atIndex = email.indexOf('@');
  if(atIndex === -1){
    return;
  }

  const localPart = atIndex !== -1 ? email.slice(0, atIndex) : email;
  const domainPart = atIndex !== -1 ? email.slice(atIndex + 1) : '';

  const findFirstDisallowed = (str: string, allowed: Set<string>): string | null => {
    for (const char of str) {
      if (!allowed.has(char)) return char;
    }
    return null;
  };

  // Validate local part and domain part separately to provide specific error messages
  if (localPart) {
    const foundSymbol = findFirstDisallowed(localPart, ALLOWED_EMAIL_LOCAL_CHARS);
    if (foundSymbol !== null) {
      emailEl?.setAttribute('title', errorMessage('PROHIBITED_SYMBOLS_EMAIL_LOCAL_MSG', { symbol: foundSymbol }));
      return;
    }
  }

  // Validate domain part only if it exists
  if (domainPart) {
    const foundSymbol = findFirstDisallowed(domainPart, ALLOWED_EMAIL_DOMAIN_CHARS);
    if (foundSymbol !== null) {
      emailEl?.setAttribute('title', errorMessage('PROHIBITED_SYMBOLS_EMAIL_DOMAIN_MSG', { symbol: foundSymbol }));
    }
  }
};

const validateDuplicateEmail = () => {
  const normalizedEmail1 = normalizeEmail(email1.value);
  const normalizedEmail2 = normalizeEmail(email2.value);
  const isSameEmail = normalizedEmail1 && normalizedEmail2 && normalizedEmail1 === normalizedEmail2;

  if (isSameEmail && !isEmail1Error.value && !isEmail2Error.value) {
    isDuplicateEmailError.value = true;
    isEmail1Error.value = true;
    email1ErrorMsg.value = DUPLICATE_EMAIL_ERROR_MESSAGE;
    return true;
  }

  isDuplicateEmailError.value = false;

  if (email1ErrorMsg.value === DUPLICATE_EMAIL_ERROR_MESSAGE) {
    isEmail1Error.value = false;
    email1ErrorMsg.value = '';
  }

  return false;
};

watch(email1, validateEmail1);
watch(email2, validateEmail2);

const sendVerifyMailSecurity = async () => {
  if(isDisabledSubmit.value)
  {
    return;
  }
  else
  {
    isDisabledSubmit.value = true;
  }

  if (validateDuplicateEmail()) {
    isDisabledSubmit.value = false;
    return;
  }

  isLoading.value = true;
  store.commit('mailSecurity/setMailSecurityUpdateInfo', undefined);
  const newMailSecurityRequest: NewMailSecurityRequest = {
    email1: email1.value,
    email2: email2.value
  };

  try {
    const res = await postMailSecurityUpdateKey(newMailSecurityRequest) as MailSecurityUpdateKeyResponse;
    const resDetail = res?.detail as MailSecurityUpdateKeyDetail;
    if (resDetail) {
      if(resDetail.isSendMailError) {
        isShowAlertErrorSendMail.value = true;
      } else {
        isShowAlertErrorSendMail.value = false;
        const isEmail2Removed = normalizeEmail(email2Origin.value) !== ''
          && normalizeEmail(email2.value) === '';

        const mailSecurityUpdateInfo: MailSecurityUpdateKeyDetail = {
          ...resDetail,
          isEmail2Removed,
          originalLoginId: emailSecutiryInfo?.value?.loginId ?? ''
        };
        store.dispatch('mailSecurity/clear');
        store.commit('mailSecurity/setMailSecurityUpdateInfo', mailSecurityUpdateInfo);
        store.commit('mailSecurity/setMailSecurityCommonLayout', isCommonLayoutVisibleOnForm.value);
        router.push({ name: 'mss04' });
      }
    }
  } 
  catch (err) {
    const error = err as { response: { data: Array<MailSecurityItemError> }};
    const errItems = error?.response?.data as Array<MailSecurityItemError>;
    if(Array.isArray(errItems) && errItems.length > 0 ) {
      errItems.forEach((err: MailSecurityItemError) => {
        if(err?.field == 'email1') {
          isEmail1Error.value = true;
          email1ErrorMsg.value = err?.message ?? '';
        }

        if(err?.field == 'email2') {
          isEmail2Error.value = true;
          email2ErrorMsg.value = err?.message ?? '';
        }
      });
    };
  }
  finally {
    isLoading.value = false;
  }

  isDisabledSubmit.value = false;
};

const selectMailSugget = (emailNumber: string, emailSugget: string) => {
  if(emailNumber == 'email1') {
    email1.value = emailSugget;
  }

  if(emailNumber == 'email2') {
    email2.value = emailSugget;
  }
};

const setIsEnableSubmitButton = () => {
  if(emailSecutiryInfo?.value?.email1AuthFlg !== 1 || (emailSecutiryInfo?.value?.email2 && emailSecutiryInfo?.value?.email2AuthFlg !== 1)) {
    isEnableSubmitButton.value = true;
  } else {
    if(email1Origin.value != email1.value || email2Origin.value != email2.value) {
      isEnableSubmitButton.value = true;
    } else {
      isEnableSubmitButton.value = false;
    }
  }
};

function scrollToTop() {
  domHelperUtils.scrollToTop();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          _createElementVNode("a", {
            href: "",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(router).back()), ["prevent"]))
          }, _hoisted_6),
          _hoisted_7
        ]),
        _createElementVNode("form", {
          class: "p-recommend-inner -is-mail-security-2",
          action: "",
          method: "post",
          onSubmit: _withModifiers(sendVerifyMailSecurity, ["prevent"])
        }, [
          _hoisted_9,
          (_unref(isShowProcedure))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("p", _hoisted_16, _toDisplayString(loginId.value), 1),
            _hoisted_17
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("h2", _hoisted_19, [
              _createTextVNode("メールアドレス1（ログインID） "),
              _hoisted_20,
              _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(email1AuthLabel)), 1)
            ]),
            (isEmail1Error.value)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "p-mail-security-notice --error u-mb-8-sp u-mb-10-pc",
                  innerHTML: email1ErrorMsg.value
                }, null, 8, _hoisted_22))
              : _createCommentVNode("", true),
            (_unref(isShowEmail1SwapNotice))
              ? (_openBlock(), _createElementBlock("p", _hoisted_23, "メールアドレスの変更により、再度認証が必要です。"))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["p-mail-security-input-1", isEmail1Error.value && '--error']),
              type: "email",
              placeholder: "メールアドレスを入力してください",
              id: "email1",
              ref_key: "email1Input",
              ref: email1Input,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email1).value = $event)),
              maxlength: "255"
            }, null, 2), [
              [_vModelText, email1.value]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listEmailSuggestForEmail1), (email, idx) => {
              return (_openBlock(), _createElementBlock("div", { key: idx }, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (selectMailSugget('email1', email)),
                  class: "p-mail-security-mail-button",
                  type: "button"
                }, [
                  _createElementVNode("span", null, _toDisplayString(email), 1)
                ], 8, _hoisted_24)
              ]))
            }), 128))
          ]),
          (_unref(isEmail2InputVisible))
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("h2", _hoisted_26, [
                  _createTextVNode("メールアドレス2 "),
                  (_unref(email2AuthLabel) !== null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_unref(email2AuthLabel)), 1))
                    : _createCommentVNode("", true)
                ]),
                (isEmail2Error.value)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "p-mail-security-notice --error u-mb-8-sp u-mb-10-pc",
                      innerHTML: email2ErrorMsg.value
                    }, null, 8, _hoisted_28))
                  : _createCommentVNode("", true),
                (_unref(showEmail2ClearNotice))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_unref(EMAIL2_CLEAR_NOTICE_MESSAGE)), 1))
                  : _createCommentVNode("", true),
                (_unref(isShowEmail2SwapNotice))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_30, "メールアドレスの変更により、再度認証が必要です。"))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["p-mail-security-input-1", (isEmail2Error.value || isDuplicateEmailError.value) && '--error']),
                  type: "email",
                  placeholder: "メールアドレスを入力してください",
                  id: "email2",
                  ref_key: "email2Input",
                  ref: email2Input,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((email2).value = $event)),
                  maxlength: "255"
                }, null, 2), [
                  [_vModelText, email2.value]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listEmailSuggestForEmail2), (email, idx) => {
                  return (_openBlock(), _createElementBlock("div", { key: idx }, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (selectMailSugget('email2', email)),
                      class: "p-mail-security-mail-button",
                      type: "button"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(email), 1)
                    ], 8, _hoisted_31)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("button", {
              class: "p-recommend-button --type-1 --width-1",
              type: "submit",
              disabled: isEmail1Error.value || isEmail2Error.value || !isEnableSubmitButton.value
            }, "変更する ", 8, _hoisted_33)
          ])
        ], 40, _hoisted_8)
      ])
    ]),
    (isShowAlertErrorSendMail.value)
      ? (_openBlock(), _createBlock(MailSecurityPopupView, {
          key: 0,
          isShowCloseBtnPopup: true,
          isShowSecondClosePopup: true,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (isShowAlertErrorSendMail.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_34
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("a", {
        class: "g-pagetop",
        href: "#",
        "aria-label": "ページトップへ戻る",
        onClick: _withModifiers(scrollToTop, ["prevent"])
      }, _hoisted_38, 8, _hoisted_36)
    ])
  ]))
}
}

})